import { IconArrowDown, IconArrowUp, IconSort } from '@iwoca/icons';
import { Table } from '@iwoca/orion';
import { clsx } from 'clsx';

import { OrderingParam, SortKey } from '../../CustomersV2.types';
import { nextSort } from '../../hooks/nextSort';

export const SortableHeaderCell = ({
  header,
  sortKey,
  explicitSort,
  defaultSort,
  className,
  onSort,
}: {
  header: string;
  sortKey: SortKey;
  explicitSort: OrderingParam | null;
  defaultSort: OrderingParam;
  className?: string;
  onSort: (value: OrderingParam | null) => void;
}) => {
  const effectiveSort = explicitSort ?? defaultSort;
  const direction =
    effectiveSort === sortKey
      ? 'ascending'
      : effectiveSort === `-${sortKey}`
        ? 'descending'
        : 'none';

  const Icon = {
    ascending: IconArrowUp,
    descending: IconArrowDown,
    none: IconSort,
  }[direction];

  return (
    <Table.HeaderCell
      aria-sort={direction}
      // Orion styles every header cell from a two-class selector, so the sorted
      // background and underline have to outrank it.
      className={clsx(
        direction !== 'none' &&
          '!border-b-[3px] !border-b-primary-90 !bg-secondary-95',
        className,
      )}
    >
      <button
        type="button"
        onClick={() => onSort(nextSort(sortKey, explicitSort, defaultSort))}
        className="flex cursor-pointer items-center gap-s border-none bg-transparent p-0 uppercase [color:inherit] [font:inherit]"
      >
        {header}
        <Icon height={16} width={16} />
      </button>
    </Table.HeaderCell>
  );
};
